exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gantt-elastic__header-title {\n\topacity: 0;\n}\n", ""]);

// exports
